import { ActivityStatusBar } from 'components/common/ActivityStatusBar/ActivityStatusBar';
import classes from 'components/common/Tables/Cells/StatusCell/StatusCell.module.scss';

import { IProjectStatus } from 'components/Dashboards/Portfolio/phasePerformance/phasePerformance.types';

import { Status as IStatus, getStatusColor, getStatusLabel } from 'utilitys/Status/Status.utils';

export interface Props {
    status: IProjectStatus;
    projectName: string;
}

export const ProjectStatus = ({ status, projectName }: Props) => {
    return (
        <div className={classes.statusCell} id={`phase_performance_project_${projectName}_status`}>
            <ActivityStatusBar type={getStatusColor(status as IStatus)} value={getStatusLabel(status as IStatus)} />
        </div>
    );
};
